import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

export interface SwayyRoute {
  path: string;
  exact?: boolean;
  element: React.ComponentType;
}

interface AppContentProps {
  routes: SwayyRoute[];
}

const AppContent = ({ routes }: AppContentProps) => {
  return (
    <Suspense
      fallback={
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      }
    >
      <Routes>
        {routes.map((route, idx) => {
          return (
            route.element && (
              <Route key={idx} path={route.path} element={<route.element />} />
            )
          );
        })}
      </Routes>
    </Suspense>
  );
};

export default React.memo(AppContent);
